/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { getEndpoints } from "./endpoints";
import { getTimezones } from "./timezones";

const apiUrl = `https://app.deliwell.eu`;
const endpoints = getEndpoints(apiUrl);
const timezones = getTimezones();

export const environment = {
  production: true,
  showSignup: true,
  googleApiKey: 'AIzaSyDXQVfY9z7iQj-YHyZ2Sc4cteS6hfZa4yI',
  serviceWorker: true,
  accessUnavailableFeatures : true,
  marketingAnalyticsCookieDomain: '.deliwell.eu',
  issueManagerUrl: 'https://app.deliwell.eu/issue-manager-client',
  firebase: {
    apiKey: 'AIzaSyDmzxingOtDmR5JzIGf3LLLY55D90gLbtE',
    authDomain: 'well-delivery-irian.firebaseapp.com',
    databaseURL: 'https://well-delivery-irian.firebaseio.com',
    projectId: 'well-delivery-irian',
    storageBucket: 'well-delivery-irian.appspot.com',
    messagingSenderId: '825195199491'
  },
  deliwellFirebase: {
    apiKey: "AIzaSyBzUlT_9wHoX85XcOFDey7vUgLpQoEpDgQ",
    authDomain: "deliwell.firebaseapp.com",
    projectId: "deliwell",
    storageBucket: "deliwell.appspot.com",
    messagingSenderId: "1022163831409",
    appId: "1:1022163831409:web:82f9b3d56fbc02b788e9d0",
    vapidKey: "BO-UneNzWsEMGH4yg4uQhonMo3ROY2v8E9PQ9hQkC-MwDmCiwyS4nzvyNMdFPn_iQWCnndudgPOViUKepE7nHgY"
  },
  htmlToPdfUrl: `http://html-to-pdf-prod.eu-central-1.elasticbeanstalk.com/html-to-pdf`,
  oidc: {
    issuer: 'https://app.deliwell.eu/authorization',
    clientId: 'angular-spa',
    redirectUri: 'https://app.deliwell.eu/app/auth/login-callback',
    postLogoutRedirectUri: 'https://app.deliwell.eu/app/auth/login',
    scope: 'openid profile email api.read',
    authorizationEndpoint: 'https://app.deliwell.eu/authorization/oauth2/authorize',
    tokenEndpoint: 'https://app.deliwell.eu/authorization/oauth2/token',
    logoutEndpoint: 'https://app.deliwell.eu/authorization/connect/logout',
    requireHttps: true,
    production: true,
  },
  ...endpoints,
  ...timezones
};

